// extracted by mini-css-extract-plugin
export default {"divider":"InstrumentDashboard_divider__MN3Ft"};